import {TeacherService} from '../services';
import {bindLoading} from './index';

export default {
    namespaced: true,
    state: {
        teachers: [],
    },

    mutations: {
        saveTeachers(current, teachers) {
            current.teachers.splice(0);
            current.teachers = teachers;
        }
    },

    actions: {
        async getTeachersWithKeyAction({commit}, key) {
            await bindLoading(commit,
                async () => commit('saveTeachers', await TeacherService.getTeachersWithKey(key)), 'teacher');
        }
    }
}